module.exports = __webpack_public_path__ + "img/main.c4896f98.png";